(()=>{"use strict";
const D=document;

function assurance(){
  const el=D.createElement("div");
  el.className="lm-cart-assurance";
  el.setAttribute("data-lm-cart-assurance","");
  el.innerHTML='<span class="lm-cart-assurance__secure">Secure checkout</span><a href="/pages/contact">Need sizing help? Client Care</a>';
  return el
}

function drawer(){
  const d=D.querySelector("#CartDrawer");
  if(!d)return;
  const w=d.querySelector(".hdt-mini-cart__bottom-wrap");
  if(!w||w.querySelector("[data-lm-cart-assurance]"))return;
  const firstCta=w.querySelector(".hdt-mini-cart__btn-checkout,.hdt-mini-cart__btn-viewcart");
  if(firstCta)firstCta.insertAdjacentElement("beforebegin",assurance());
  else w.append(assurance())
}

function collapseDiscount(p){
  const coupon=p.querySelector(".hdt-page-cart__coupon");
  if(!coupon||coupon.dataset.lmDiscountReady)return;

  coupon.dataset.lmDiscountReady="true";
  coupon.classList.add("lm-cart-discount-panel");

  const input=coupon.querySelector("[data-cart-discount-input]");
  const isActive=!!(input&&((input.value||"").trim()||(input.dataset.value||"").trim()));

  const toggle=D.createElement("button");
  toggle.type="button";
  toggle.className="lm-cart-discount-toggle";
  toggle.setAttribute("data-lm-discount-toggle","");
  toggle.setAttribute("aria-expanded",isActive?"true":"false");
  toggle.textContent=isActive?"Discount code":"Have a discount code?";

  coupon.classList.toggle("is-open",isActive);
  coupon.insertAdjacentElement("beforebegin",toggle);

  toggle.addEventListener("click",()=>{
    const open=!coupon.classList.contains("is-open");
    coupon.classList.toggle("is-open",open);
    toggle.setAttribute("aria-expanded",open?"true":"false");
    if(open)setTimeout(()=>input&&input.focus(),50)
  })
}

function mobileCheckout(p){
  let bar=D.querySelector("[data-lm-mobile-checkout]");
  const count=Number(p?.getAttribute("data-count")||0);

  if(!p||!count){
    if(bar)bar.remove();
    D.body.classList.remove("lm-mobile-cart-sticky");
    return
  }

  if(!bar){
    bar=D.createElement("div");
    bar.className="lm-mobile-checkout-bar";
    bar.setAttribute("data-lm-mobile-checkout","");
    bar.setAttribute("role","region");
    bar.setAttribute("aria-label","Cart checkout");
    bar.innerHTML='<div class="lm-mobile-checkout-bar__total"><span>Subtotal</span><strong data-lm-mobile-total></strong></div><button form="CartPage-Form" type="submit" name="checkout">Checkout</button>';
    D.body.append(bar)
  }

  const total=bar.querySelector("[data-lm-mobile-total]");
  if(total)total.textContent=p.getAttribute("data-total-price")||"";
  D.body.classList.add("lm-mobile-cart-sticky")
}

function page(){
  const p=D.querySelector("#hdt-page-cart");
  if(!p){
    mobileCheckout(null);
    return
  }

  const b=p.querySelector(".hdt-main-cart__button-checkout");
  if(b&&!p.querySelector("[data-lm-cart-assurance]"))b.insertAdjacentElement("beforebegin",assurance());

  collapseDiscount(p);
  mobileCheckout(p)
}

function init(){drawer();page()}

let queued=false;
const schedule=()=>{
  if(queued)return;
  queued=true;
  requestAnimationFrame(()=>{queued=false;init()})
};

function observe(){
  new MutationObserver(schedule).observe(D.body,{
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:["data-count","data-total-price"]
  })
}

D.addEventListener("shopify:section:load",schedule);
if(D.readyState==="loading"){
  D.addEventListener("DOMContentLoaded",()=>{init();observe()},{once:true})
}else{
  init();
  observe()
}
})();
